<template>
    <header>
        <div class="container">
            <div class="header-left">
                <div v-if="user.uid">
                    <router-link to="/landing">
                        <img class="logo" src="../assets/ritsbook_logo2.svg">
                    </router-link>
                </div>
                <div v-else>
                    <router-link to="/">
                        <!-- <img class="logo" src="../assets/ritsbook_logo_with_itsname(1).svg"> -->
                        <img class="logo" src="../assets/ritsbook_logo2.svg">
                    </router-link>
                </div>
            </div>
            <div class="header-right">
            <div v-if="user.uid" class="btn-wrapper">
                <!-- <a class="login" href="../landing/langing.html">ログアウト</a> -->
                <!-- <router-link to="/"> -->
                    <button type="button" @click="doLogout" class="btn register">ログアウト</button>
                <!-- </router-link> -->
            </div>    
        </div>
    </div>
    </header>
</template>

<script>
import firebase from 'firebase'
export default {
    name: 'Header',
    data(){
        return {
            user: {},  // ユーザー情報
        }
    },
    created() {
      firebase.auth().onAuthStateChanged(user => {
        this.user = user ? user : {}
      })
    },
    methods: {
        doLogout(){
            this.$router.push({path:"/"})
            firebase.auth().signOut()
        }
    }
}
</script>

<style scoped>
* {
    margin: 0; 
    padding: 0;
    box-sizing: border-box;
}

.container {
    width: 100%;
    padding: 0 15px;
    margin: 0 auto;
}

header {
    height: 60px;
    width: 100%;
    background-color: rgb(255, 255, 255);
    color: rgb(255, 255, 255);
    top: 0;
    z-index: 10;
    border-bottom:solid 1px rgb(200, 200, 200) ;
}

.header-left{
    float: left;
}

.logo{
    width: 160px;
    line-height: 60px;
    height: 60px;
}

.header-right button{
    float: right;
    line-height: 30px;
    color: black;
    margin-top: 15px;
    padding: 0px 15px;
    border: solid 1px;
    border-color: black;
    /* background-color: rgb(200, 200, 200); */
}

.header-right button:hover {
    background-color: rgba(200, 200, 200, 0.3);
    transition: all 0.3s;
  }
</style>
